module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: {
      'disabled': _vm.current == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(_vm.current - 1)
      }
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-page-first point"
  })])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.current == 1
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(1)
      }
    }
  }, [_vm._v(" 首页 ")])]), _vm._v(" "), _vm._l((_vm.grouplist), function(p) {
    return _c('li', {
      class: {
        'active': _vm.current == p.val
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.setCurrent(p.val)
        }
      }
    }, [_vm._v(" " + _vm._s(p.text) + " ")])])
  }), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.current == _vm.page
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(_vm.page)
      }
    }
  }, [_vm._v(" 尾页 ")])]), _vm._v(" "), _c('li', {
    class: {
      'disabled': _vm.current == _vm.page
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.setCurrent(_vm.current + 1)
      }
    }
  }, [_c('span', {
    staticClass: "icon iconfont icon-page-last point"
  })])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b568df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagination/index.vue
// module id = 508
// module chunks = 1